module.exports = __webpack_public_path__ + "static/49-430d6862ea46686ab64f900bef54e9dc.png";